import { apiUrl } from '../constants/globals';

/**
 * Service for interacting with the ROI chat endpoints
 */
export async function sendMessage(token, message) {
    try {
        const response = await fetch(`${apiUrl}/students/chat/send`, {
            method: 'POST',
            headers: new Headers({
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }),
            body: JSON.stringify({
                message
            })
        });
        return await response.json();
    } catch (error) {
        console.error('Error sending message:', error);
        throw error;
    }
}

/**
 * Get chat history
 * @param {number} page - Page number for pagination (optional)
 * @param {number} perPage - Number of messages per page (optional)
 * @returns {Promise} - The chat history
 */
export async function getMessages(token, page = 1, perPage = 50) {
    try {
        const response = await fetch(`${apiUrl}/students/chat/messages?page=${page}&per_page=${perPage}`, {
            method: 'GET',
            headers: new Headers({
                'Authorization': `Bearer ${token}`
            })
        });
        return await response.json();
    } catch (error) {
        console.error('Error getting messages:', error);
        throw error;
    }
} 